<template lang="pug">
  .support
    van-nav-bar(:title="$t('support.title')")
      van-icon(name="menu" slot="left" @click="openSidenav")

    .main
      .support__list(
        v-if="content.length"
        v-for="theme in content"
        :key="theme.title")
        .van-cell-group__title {{ theme.title}}

        van-cell-group(
          v-if="theme.subthread.length"
          v-for="unit in theme.subthread"
          :key="unit.title")
          van-cell(
            is-link
            icon="document"
            :title="unit.title"
            @click="showDocs(theme, unit)")

      .support__list
        .van-cell-group__title.support__version(v-if="version") Version {{ version }}

    //- Popup Mostrar documentación
    RenderDocs(
      v-if="openDocs"
      base="support/"
      :docData="docData"
      @close="hideDocs")
</template>

<script>
import i18n from '@/locales/i18n';
import axios from 'axios';
import { mapActions } from 'vuex';
import RenderDocs from '@/components/RenderDocs.vue';

export default {
  components: { RenderDocs },
  data() {
    return {
      content: [],
      openDocs: false,
      docData: null,
      version: null,
    };
  },
  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    getVersion() {
      const path = '/change_log.json';
      const instance = axios.create({ baseURL: 'support/' });
      instance.get(path).then(response => {
        if (
          response.data.change_log &&
          Array.isArray(response.data.change_log) &&
          response.data.change_log.length
        ) {
          this.version = response.data.change_log[response.data.change_log.length - 1].version;
        }
      });
    },

    getContents() {
      const path = `${i18n.locale.toLowerCase()}/content.json`;
      const instance = axios.create({ baseURL: 'support/' });
      instance.get(path).then(response => {
        this.content = response.data.thread;
      });
    },

    /**
     * Muestra el popup con la documentación
     */
    showDocs(theme, unit) {
      console.log(theme);
      console.log(unit);
      this.docData = {
        title: unit.title,
        video: unit.video ? unit.video : '',
        path: `${i18n.locale.toLowerCase()}/${theme.path}/${unit.file}`,
      };
      this.openDocs = true;
    },

    /**
     * Oculta el popup con la documentación
     */
    hideDocs() {
      this.docData = null;
      this.openDocs = false;
    },
  },
  mounted() {
    this.getContents();
    this.getVersion();
  },
};
</script>
